
import AuthenticatorHeader from "./AuthenticatorHeader.vue";
import NavigationButton from "./NavigationButton.vue";
import PasswordRequirements from "./PasswordRequirements.vue";
import { focusRequiredEmptyInput } from "@/util/auth-ui";
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";
import { defineComponent, ref } from "vue";

export default defineComponent({
  components: { AuthenticatorHeader, NavigationButton, PasswordRequirements },
  setup() {
    const { submitNewPassword } = useGammaAuthenticator();

    const password = ref("");
    const confirmPassword = ref("");
    const errorMessage = ref<string | undefined>(undefined);
    const loading = ref(false);

    const passwordRef = ref();
    const confirmPasswordRef = ref();

    const isPasswordValid = ref(false);

    async function changePassword() {
      focusRequiredEmptyInput([
        passwordRef.value.$el,
        confirmPasswordRef.value.$el,
      ]);

      if (!isPasswordValid.value) return;

      loading.value = true;
      try {
        await submitNewPassword(password.value);
      } catch (error) {
        errorMessage.value = error.message;
      }
      loading.value = false;
    }

    return {
      AuthUIState,
      password,
      confirmPassword,
      passwordRef,
      confirmPasswordRef,
      errorMessage,
      loading,
      isPasswordValid,
      changePassword,
    };
  },
});
